const ListPageHeader = ({ styles }: any) => {
    return (
        <div className={styles.pageHeaderContainer}>
            <div>
                <span className="component_header">Lead list</span>
            </div>
        </div>
    );
};
export default ListPageHeader;